import React from 'react';
import { useState } from 'preact/hooks';
import { Collapse } from 'antd';
import { TextHeadTitle } from '../../../components/text';
import { LISTFORMSTEPONE } from '../forms/forms.js';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { PageLayout } from '../../../components/page-layout/PageLayout';
import { HelpModal } from '../modal';
import { BATTERYHELP, MODELHELP, ACCESSORIESHELP, WARRANTYHELP, FRAMECONDITION, BACKCAMERAHELP, BACKFRAMEHELP, DISPLAYHELP, USEDHELP } from '../constant';
import { useMediaQuery } from 'react-responsive';

const { Panel } = Collapse;

export const StepFirst = ({ data, options, fn }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [titleModal, setTitleModal] = useState('');
  const [openModalHelp, setOpenModalHelp] = useState(false);
  const [dataModal, setDataModal] = useState([]);
  const { productName, dataStepOne, activeKey } = data;
  const { handleSelect, toggleCollapse } = fn;
  const {
    region,
    warranty,
    frameCondition,
    displayCondition,
    backCoverCondition,
    backCameraConditions,
    battery,
    accessories,
    usedCondition,
  } = options;

  const openHelp = (event, key, texthelp) => {
    event.stopPropagation();
    switch (key) {
      case '1':
        setDataModal(MODELHELP);
        break;
      case '2':
        setDataModal(WARRANTYHELP);
        break;
      case '3':
        setDataModal(FRAMECONDITION);
        break;
      case '4':
        setDataModal(DISPLAYHELP)
        break;
      case '5':
        setDataModal(BACKFRAMEHELP)
        break;
      case '6':
        setDataModal(BACKCAMERAHELP)
        break;
      case '7':
        setDataModal(BATTERYHELP);
        break;
      case '8':
        setDataModal(ACCESSORIESHELP);
        break;
      case '9':
        setDataModal(USEDHELP);
        break;
    }
    setTitleModal(texthelp);
    setOpenModalHelp(true);
  };

  return (
    <>
      <TextHeadTitle text={`ระบุข้อมูลการขาย ${productName} ที่คุณเลือก`} bold />
      <PageLayout
        content={
          <Collapse expandIconPosition={'end'} activeKey={activeKey} onChange={toggleCollapse}>
            {LISTFORMSTEPONE({
              list: {
                region,
                warranty,
                frameCondition,
                displayCondition,
                backCoverCondition,
                backCameraConditions,
                battery,
                accessories,
                usedCondition,
              },
              fn: {
                handleSelect,
                handleHelp: (data, title) => {
                  setDataModal(data);
                  if (title) setTitleModal(title);
                  setOpenModalHelp(true);
                },
              },
              dataStepOne,
            }).map((el, i) => {
              return (
                <Panel
                  header={
                    <div>
                      <span className="collapse-title">{el.label}</span>
                      <span
                        className="collapse-title-help"
                        onClick={(event) => openHelp(event, el.key, el.texthelp)}
                      >
                        <QuestionCircleOutlined className="icon-help" /> {!isMobile && el.texthelp}
                      </span>
                    </div>
                  }
                  key={`${i}`}
                >
                  {el.content}
                </Panel>
              );
            })}
          </Collapse>
        }
      />
      <HelpModal
        open={openModalHelp}
        onToggle={() => setOpenModalHelp(!openModalHelp)}
        title={titleModal}
        data={dataModal}
      />
    </>
  );
};
